import { render, staticRenderFns } from "./project_list.vue?vue&type=template&id=505d9c71&scoped=true"
import script from "./project_list.vue?vue&type=script&lang=js"
export * from "./project_list.vue?vue&type=script&lang=js"
import style0 from "./project_list.vue?vue&type=style&index=0&id=505d9c71&prod&scoped=true&lang=css"
import style1 from "./project_list.vue?vue&type=style&index=1&id=505d9c71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d9c71",
  null
  
)

export default component.exports